import Analytics from 'analytics'
import cdpDumpPlugin from './cdpDumpPlugin'

let analytics = null

function initAnalytics() {
  analytics = Analytics({
    app: 'plickers-web',
    plugins: [
      cdpDumpPlugin({
        appName: 'plickers-web',
        writeKey: process.env.REACT_APP_CDPDUMP_WRITE_KEY,
        host: process.env.REACT_APP_CDPDUMP_HOST,
        endpointPrefix: '/cdp/v1',
        // enableDebugLogging: true, // enable this to get more logs into browser console
      }),
    ],
  })
}

function getAnalyticsInstance() {
  if (!analytics) initAnalytics()
  return analytics
}

function track(eventName, properties = {}) {
  const analytics = getAnalyticsInstance()
  analytics.track(eventName, properties)
}

function page(pageName, properties = {}) {
  const analytics = getAnalyticsInstance()
  analytics.page({
    name: pageName,
    ...properties,
  })
}

function identify(userId, traits = {}) {
  const analytics = getAnalyticsInstance()
  analytics.identify(userId, traits)
}

function reset() {
  const analytics = getAnalyticsInstance()
  analytics.reset()
}

export default {
  initAnalytics,
  track,
  page,
  identify,
  reset,
}
